import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Paper,
  Typography,
  styled
} from '@mui/material';

window.showModal = null;


const ModalPaper = styled(Paper)({
  textAlign: 'center !important',
  maxWidth: 310,
  padding: 25,
  "& > *": {
    textAlign: 'center !important',
  },
  "& > button": {
    height: "56px",
    marginBottom: "0px",
  },
});

export default function GlobalModal() {
  const [modalConfig, setModalConfig] = useState({
    isOpen: false,
    header: '',
    content: '',
    button: '',
    onAccept: () => { },
    onReject: () => { }
  });

  useEffect(() => {
    window.showModal = (config) => setModalConfig({ ...config, isOpen: true });
  }, []);

  const handleClose = () => {
    setModalConfig(prev => ({ ...prev, isOpen: false }));
    modalConfig.onReject?.();
  };

  const handleAccept = () => {
    setModalConfig(prev => ({ ...prev, isOpen: false }));
    modalConfig.onAccept?.();
  };

  return (
    <Dialog open={modalConfig.isOpen} onClose={handleClose} maxWidth="xs"
      PaperProps={{
        sx: {
          padding: '0px !important'
        }
      }}
    >
      <ModalPaper>
        <Typography variant="h4" color="primary"
          mb={'6px'}
          fontSize={'22px'}
        >{modalConfig.header}</Typography>
        <Typography variant="body1" color="primary"
          mb={'20px'}
          sx={{
            fontSize: '14px',
            fontWeight: '400',

          }}
        >{modalConfig.content}</Typography>

        {modalConfig.button && (
          <Button onClick={handleAccept} variant="contained" fullWidth>
            {modalConfig.button}
          </Button>
        )}
      </ModalPaper>
    </Dialog>
  );
}